import NoticeboardAPICall from "NoticeboardAPICall";
import config from "config";

// GET CERTIFICATE ACCESS DETAILS ACTION CREATOR  
export const getNoticeAccessDetails = () => {
    return async dispatch  => {
		// METHOD TO DISPATCH SET ADMIN FETCHING ACTION CREATOR
		dispatch(setAdminFetching(true));

		let requestData = {
            'institute_id': config.institute_id,
            'user_id': config.faculty_id,
            'stream_id': config.stream_id
		};
	
		let jsonResponse = await NoticeboardAPICall.makeApiCall(
			'GetNoticeBoardAccessDetails',
			requestData,
			'/api/instructor/noticeboard.php'
		);
	
		if (jsonResponse.expired) {
			setTimeout(() => {
				dispatch(getNoticeAccessDetails());
			}, 1000);
		} else {
			if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.access_provided;

				let isNoticeAdmin = apiResult.manage_notice.isAccessGranted == 'false' ? false : true;
				let isCategoryAdmin = apiResult.manage_notice_category.isAccessGranted == 'false' ? false : true;
				
				// METHOD TO DISPATCH SET ADMIN FETCHING ACTION CREATOR
				dispatch(setAdminFetching(false));

                // METHOD TO DISPATCH SET NOTICE ADMIN DETAILS ACTION CREATOR
				dispatch(setNoticeAdminDetails(apiResult, isNoticeAdmin, isCategoryAdmin));
			}
		}
	}
};

// SET ADMIN FETCHING ACTION CREATOR
export const setAdminFetching = (adminFetching) => {
    return {
        type: 'SET_ADMIN_FETCHING',
        adminFetching
    };
};

// SET NOTICE ADMIN DETAILS ACTION CREATOR
export const setNoticeAdminDetails = (accessDetails, isNoticeAdmin, isCategoryAdmin) => {
    return {
        type: 'SET_NOTICE_ADMIN_DETAILS',
        payload: {
            accessDetails,
            isNoticeAdmin,
			isCategoryAdmin
        }
    };
};